export default __webpack_public_path__ + "static/media/bl.f341ec76.svg";